export enum UserType {
  ADMIN = 'admin',
  USER = 'user',
}